import React from "react";
import { CirclePlusIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// Unified "+" add entry (circle-plus icon button). Works with a direct onClick,
// or as an asChild trigger for DropdownMenu / Dialog (forwardRef). Shared by Apps / Tags / Reports on the detail page.
export const AddButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, title = "Add", ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    title={title}
    className={cn(
      "inline-flex h-6 w-6 shrink-0 items-center justify-center text-muted-foreground transition-colors hover:text-foreground disabled:opacity-50",
      className
    )}
    {...props}
  >
    <CirclePlusIcon className="h-4 w-4" />
  </button>
));
AddButton.displayName = "AddButton";
